export const NO_COLOR = 'transparent';
export const HEX_NO_COLOR = '#00000000';
export const MAX_SWATCH_COLORS = 25;
export const CLOSE_ICON_EL_ID = 'color-picker-close-icon';
export const DEFAULT_SWATCH_NUM_COLS = 6;
export const CSS_CLASS_PROJECT_COLOR_SWATCHES = 'project-color-swatches';

// style
export const COLOR_PICKER_WIDTH = 192;
export const COLOR_PICKER_POPOVER_WIDTH = 288;
export const SATURATION_BORDER = '1.5px solid var(--vg-colors-gray-200)';
export const SATURATION_BORDER_RADIUS = 'var(--vg-radii-base)';
export const SATURATION_BORDER_THICKNESS = 2;
export const SLIDER_BORDER_RADIUS = '10px';
export const SLIDER_HEIGHT = 'var(--vg-sizes-4)';
export const TRIGGER_BUTTON_SIZE = 8;
export const DEFAULT_SATURATION_BORDER_COLOR = 'var(--vg-colors-gray-200)';
export const PASS_SATURATION_BORDER_COLOR = 'var(--vg-colors-action-400)';
export const FAIL_SATURATION_BORDER_COLOR = 'var(--vg-colors-red-400)';

// styling for side menu colour picker
export const SIDE_MENU_COLOR_PICKER_WIDTH = 270;
export const SIDE_MENU_COLOR_DISPLAY_HEIGHT = 122;
